/** Mascara CPF para logs e telas: 123.456.789-09 → ***.456.789-** */
export function mascararCpf(cpf: string): string {
  const d = cpf.replace(/\D/g, '');
  if (d.length !== 11) return '***';
  return `***.${d.slice(3, 6)}.${d.slice(6, 9)}-**`;
}

/** Valida CPF pelos dígitos verificadores. */
export function cpfValido(cpf: string): boolean {
  const d = cpf.replace(/\D/g, '');
  if (d.length !== 11 || /^(\d)\1{10}$/.test(d)) return false;
  const calc = (len: number) => {
    let soma = 0;
    for (let i = 0; i < len; i++) soma += Number(d[i]) * (len + 1 - i);
    const r = (soma * 10) % 11;
    return r === 10 ? 0 : r;
  };
  return calc(9) === Number(d[9]) && calc(10) === Number(d[10]);
}

/** (11) 98765-4321 → (11) *****-4321 */
export function mascararTelefone(t: string): string {
  const d = t.replace(/\D/g, '');
  return d.length >= 4 ? `***${d.slice(-4)}` : '***';
}
